import { Box, Button, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { enqueueSnackbar } from "notistack";

const MAX_CAPACITY_PERCENT = 50;

export default function CapacityForm({ item, onClose }) {
  const [capacityRate, setCapacityRate] = useState("");

  const errorMessage = useMemo(() => {
    if (capacityRate === "") return "";
    const value = Number(capacityRate);
    if (Number.isNaN(value)) return "Vui lòng nhập số hợp lệ";
    if (value < 0) return "Vui lòng nhập giá trị lớn hơn hoặc bằng 0";
    if (value > MAX_CAPACITY_PERCENT) return `Bạn không thể thiết lập dung tích kho quá ${MAX_CAPACITY_PERCENT}%`;
    return "";
  }, [capacityRate]);

  const handleSubmit = () => {
    if (errorMessage || capacityRate === "") return;
    enqueueSnackbar("Đã cập nhật tỉ lệ dung tích kho", { variant: "success" });
    onClose();
  };

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "grey.300",
        borderRadius: "8px",
        p: 2,
        backgroundColor: "grey.50",
        mb: 2,
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={2}
      >
        <Box minWidth="220px">
          <Typography fontWeight={700}>Thiết lập dung tích kho</Typography>
          <Typography
            variant="body2"
            color="text.secondary"
          >
            {item?.name ? `${item?.name} đã chọn` : "Kho đã chọn"}
          </Typography>
        </Box>

        <Stack
          gap={0.5}
          minWidth={{ xs: "100%", md: "260px" }}
        >
          <Typography
            variant="body2"
            fontWeight={600}
          >
            Tỉ lệ dung tích kho
          </Typography>
          <TextField
            size="small"
            type="number"
            value={capacityRate}
            onChange={(e) => setCapacityRate(e.target.value)}
            error={Boolean(errorMessage)}
            placeholder="Nhập tỉ lệ"
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
              inputProps: {
                min: 0,
                max: MAX_CAPACITY_PERCENT,
              },
            }}
          />
          {errorMessage ? (
            <Typography
              variant="caption"
              color="error.main"
            >
              {errorMessage}
            </Typography>
          ) : (
            <Typography
              variant="caption"
              color="error"
            >
              Mức dung tích tối đa {MAX_CAPACITY_PERCENT}%
            </Typography>
          )}
        </Stack>

        <Stack
          direction="row"
          gap={1}
          width={{ xs: "100%", md: "auto" }}
          justifyContent={{ xs: "flex-end", md: "flex-start" }}
        >
          <Button
            variant="outlined"
            onClick={handleSubmit}
            disabled={Boolean(errorMessage) || capacityRate === ""}
          >
            Cập nhật
          </Button>
          <Button
            color="inherit"
            variant="outlined"
            onClick={onClose}
          >
            Hủy
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
